import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRouteSnapshot, NavigationEnd} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    title = 'Welcome to Axxess';
    private prefix = 'Axxess';

    constructor(private router: Router, private titleService: Title) {
    }

    ngOnInit() {
        // Set initial title
        this.titleService.setTitle(this.title);

        // Update title when navigation ends
        this.router.events.subscribe((event) => { // fires on every URL change
            if (event instanceof NavigationEnd) {
                this.title = this.getDeepestTitle(this.router.routerState.snapshot.root);
                this.titleService.setTitle(`${this.prefix} | ${this.title}`);
            }
        });
    }

    private getDeepestTitle(routeSnapshot: ActivatedRouteSnapshot): string {
        var title = routeSnapshot.data ? routeSnapshot.data['title'] : '';
        if (routeSnapshot.firstChild) {
            title = this.getDeepestTitle(routeSnapshot.firstChild) || title;
        }

        return title || '';
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts